import React from 'react';
import { MotionCard, FadeInSection } from '../ui/MotionPrimitives';

const WhyChooseUs: React.FC = () => {
  return (
    <FadeInSection className="w-full bg-white py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <div className="text-center mb-10">
          <h2 className="text-2xl font-semibold text-black md:text-3xl">
            Why Invest with Hogar Dorado House?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-4 lg:gap-8">
          {/* Card 1 */}
          <MotionCard className="border border-gray-100 bg-white p-6 rounded-none">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 mt-1">
                <div className="h-8 w-8 flex items-center justify-center bg-[#D88546] text-white">
                  <span className="text-sm font-bold">01</span>
                </div>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-black mb-2">Dual-Market Expertise</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  We actively manage investments across the stable <strong>US market</strong> and the rapidly expanding, high-yield <strong>UAE market</strong>, offering truly diversified, de-risked wealth creation opportunities.
                </p>
              </div>
            </div>
          </MotionCard>

          {/* Card 2 */}
          <MotionCard className="border border-gray-100 bg-white p-6 rounded-none">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 mt-1">
                <div className="h-8 w-8 flex items-center justify-center bg-[#D88546] text-white">
                  <span className="text-sm font-bold">02</span>
                </div>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-black mb-2">Precision and Integrity</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  We transform deep <strong>market intelligence</strong> into enduring value. Our commitment to collaboration, trust, and <strong>transparency</strong> ensures every transaction serves your long-term prosperity.
                </p>
              </div>
            </div>
          </MotionCard>

          {/* Card 3 */}
          <MotionCard className="border border-gray-100 bg-white p-6 rounded-none">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 mt-1">
                <div className="h-8 w-8 flex items-center justify-center bg-[#D88546] text-white">
                  <span className="text-sm font-bold">03</span>
                </div>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-black mb-2">Full-Service Concierge</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  From strategic <strong>development advisory</strong> and off-plan acquisitions to full-service <strong>property management</strong> and specialized <strong>UAE Golden Visa services</strong>, we cover the entire value chain.
                </p>
              </div>
            </div>
          </MotionCard>
        </div>
      </div>
    </FadeInSection>
  );
};

export default WhyChooseUs;
